module.exports = __webpack_public_path__ + "static/media/cmd.d11d8f3a.svg";